const addEventListener_ = EventTarget.prototype.addEventListener;
EventTarget.prototype.addEventListener = function (type, listener, options) {
    if (type === 'touchstart' || type === 'touchmove') {
        options = options || {};
        if (typeof options === 'object') {
            options.passive = true;
        }
    }
    addEventListener_.call(this, type, listener, options);
};


// Pozice pri vstupu na stranku
var logo = document.getElementById('fas-logo');
var container = document.querySelector('.container');
var width = container.offsetWidth;
logo.style.position = 'relative';
logo.style.top = '40vh';
logo.style.left = (width/2)+'px';
logo.style.zIndex = '3200';
logo.style.transition = 'none';
logo.style.transform = "translate(-50%, -50%)";


function updateGlobalWidth() {

    // carousel

    const com58Hero = document.querySelector('#hero.com58');
    if (com58Hero) {
        const width = window.innerWidth;
        const height = width * 9 / 16;
        com58Hero.style.height = `${height}px`;
    }

    globalWidth = window.innerWidth;
    let heroMask = document.getElementById("hero-mask");
    let maskContainer = document.getElementById("maskContainer");
    let textRight = document.getElementById("tr");
    let textLeft = document.getElementById("tl");
    let textBottom = document.getElementById("tb");
    let alayer1 = document.getElementById("a-layer-1");
    let videoWrapper = document.getElementById("video-wrapper");
    let heroAnimation = document.getElementById("hero-animation");
    let revealSection = document.querySelector(".reveal-section"); // footer made in prague
    let imageContainer = document.querySelector(".image-container"); // footer made in prague

    if ( revealSection ) {
        revealSection.style.height = globalWidth * 9 / 16 + "px";
    }
    if ( imageContainer ) {
        imageContainer.style.height = globalWidth * 9 / 16 + "px";
    }
    if ( window.scrollY < 1500 ) {

        if (globalWidth >= 1280 ) { // Jedna se o desktop a vetsi rozliseni

            // window.scrollTo(0,1); // hack pro nacteni vysky celkove vysky animace po F5, dulezite pro scroll sipku

            if (maskContainer) maskContainer.style.display = 'block'; // zobrazime masku
            if (maskContainer) maskContainer.style.left = '45%'; // zobrazime masku
            if (textRight) textRight.style.display = 'block'; // zobrazime text
            if (textLeft) textLeft.style.display = 'block'; // zobrazime text
            if (textBottom) textBottom.style.display = 'block'; // zobrazime text
            if (alayer1) alayer1.style.position = "fixed";
            if (videoWrapper) videoWrapper.style.display = 'block'; // zobrazime wrapper videa
            if (videoWrapper) videoWrapper.style.position = "fixed";
            if (videoWrapper) videoWrapper.style.zIndex = '-1';
            if (heroMask) heroMask.style.display = "none";

            document.body.style.removeProperty('overflow');
            const texts = document.querySelectorAll(".text");
            texts.forEach((text) => {
                text.style.opacity = 1;
                text.style.transform = "translateX(0) translateY(0) scale(1)";
            });


            // Animace pro texty zleva a zprava a zdola
            const leftText = document.querySelector(".from-left");
            const rightText = document.querySelector(".from-right");
            const bottomText = document.querySelector(".from-bottom");

            if (leftText) {
                leftText.style.opacity = 1;
                leftText.style.transform = "translateX(0)";  /* Text přijede zleva */
            }
            if ( rightText ) {
                rightText.style.opacity = 1;
                rightText.style.transform = "translateX(0)"; /* Text přijede zprava */
            }

            if (heroAnimation) heroAnimation.style.height = "7000px";

            if ( globalWidth >= 2560) {
                if (bottomText) bottomText.style.top = '890px';
                if (leftText) leftText.style.top = "300px";
                if (rightText) rightText.style.top = "300px";
            } else if ( globalWidth >= 1920 && globalWidth < 2560 ) {
                if (bottomText) bottomText.style.top = '790px';
                if (leftText) leftText.style.top = "270px";
                if (rightText) rightText.style.top = "270px";
            } else if ( globalWidth >= 1440 && globalWidth < 1920 ) {
                if (bottomText) bottomText.style.top = '704px';
                if (leftText) leftText.style.top = "270px";
                if (rightText) rightText.style.top = "270px";
            } else if ( globalWidth >= 1280 && globalWidth < 1440 ) {
                if (bottomText) bottomText.style.top = '624px';
                if (leftText) leftText.style.top = "240px";
                if (rightText) rightText.style.top = "240px";
            }

            // bottomText.style.top = "824px";  /* Nová pozice - střed obrazovky */
            if(bottomText) bottomText.style.opacity = 1;
            if(bottomText) bottomText.style.transform = "translateX(-50%) translateY(-50%)"; /* Tlačí text do středu */

        } else { // jedna se o tablet nebo mobilni rozliseni

            if (maskContainer) maskContainer.style.display = 'none'; // skryjeme masku
            if (textRight) textRight.style.display = 'none'; // skryjeme text
            if (textLeft) textLeft.style.display = 'none'; // skryjeme text
            if (textBottom) textBottom.style.display = 'none'; // skryjeme text
            if (alayer1) alayer1.style.position = "relative";
            if (videoWrapper) videoWrapper.style.position = "relative";
            if (videoWrapper) videoWrapper.style.top = "0";
            if (heroAnimation) heroAnimation.style.height = "100%";
            if (heroMask) heroMask.style.display = "none";
            document.body.style.removeProperty('overflow');

        }

        if (maskContainer) {
            maskContainer.style.width = globalWidth + "px";

            if ( globalWidth >= 2560 ) {
                maskContainer.style.height = '1440px';
            } else if (globalWidth >= 1920 && globalWidth < 2560) {
                maskContainer.style.height = '1080px';
            } else if (globalWidth >= 1440 && globalWidth < 1920) {
                maskContainer.style.height = '900px';
            } else if (globalWidth >= 1280 && globalWidth < 1440) {
                maskContainer.style.height = '800px';
            } // mensi uz neanimujeme

        }

    } else if (window.scrollY > 1500) {

        if (textRight) textRight.style.display = 'none'; // skryjeme text
        if (textLeft) textLeft.style.display = 'none'; // skryjeme text
        if (textBottom) textBottom.style.display = 'none'; // skryjeme text

        if (maskContainer) maskContainer.style.display = 'none'; // skryjeme text
        if (videoWrapper) videoWrapper.style.display = 'none'; // skryjeme text
    }
}



var globalWidth = window.innerWidth;
var globalHeight = window.innerHeight;

updateGlobalWidth();
window.addEventListener('resize', updateGlobalWidth);

// Zajistí, že se stránka načte vždy nahoře
// TODO: to je ale uzitecne pouze na HOMEPAGE
document.addEventListener("DOMContentLoaded", function () {
    // 1. Při reloadu stránky odscrolluj nahoru, ale jen pokud neobsahuje kotvu
    if (window.scrollY > 0 && !window.location.hash) {
        window.scrollTo(0, 0);
    }

    // 2. Plynulé scrollování pro anchor odkazy
    document.querySelectorAll("a[href^='#']").forEach(anchor => {
        anchor.addEventListener("click", function (e) {
            e.preventDefault(); // Zabrání klasickému skoku
            const targetId = this.getAttribute("href").substring(1);
            const targetElement = document.getElementById(targetId);

            if (targetElement) {
                targetElement.scrollIntoView({
                    behavior: "smooth",
                    block: "start"
                });

                // Oprava problému s pevnou hlavičkou (pokud existuje)
                window.scrollBy(0, -50); // Posun zpět o výšku headeru
            }
        });
    });
});

const navbarMask = document.getElementById("navbar-mask");
let timeout;

// vychozi navbar
let menu = document.getElementById('navbar');
let hero = document.getElementById('hero');
if ( menu && hero ) {
    menu.classList.add('bg-transparent');
    menu.classList.remove('bg-pastel-aqua');
}




let locked = false;
const lockY = 5000;
const lockRange = 500;
const lockDuration = 250; // v ms
function lockScroll(y, range = 200, duration = 1000) {
    if (locked) return;
    if (window.location.hash) return;
    const lastLockTime = parseInt(localStorage.getItem('lastLockTime') || '0');
    const now = Date.now();

    if (now - lastLockTime - 2000 < duration) {
        // console.log('Already locked, skipping scroll lock.');
        return;
    }

    if (window.scrollY >= y && window.scrollY < y + range) {
        // console.log('Locking scroll for', duration, 'ms');
        locked = true;
        localStorage.setItem('lastLockTime', now.toString());

        // Výpočet šířky scrollbar
        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

        window.scrollTo({ top: y, behavior: 'auto' });
        document.body.style.overflow = 'hidden';
        document.body.style.paddingRight = scrollbarWidth + 'px'; // přidáme odsazení
        document.body.style.backgroundColor = '#89EFEC';
        document.getElementById('navbar').style.paddingRight = scrollbarWidth + 'px'; // přidáme odsazení)

        setTimeout(() => {
            document.body.style.overflow = '';
            document.body.style.paddingRight = ''; // odstraníme odsazení
            document.body.style.backgroundColor = '';
            document.getElementById('navbar').style.paddingRight = ''; // odstraníme odsazení
            locked = false;
        }, duration);
    }
}


let lastScrollTop = 0;
// SCROLL SVG
window.addEventListener("scroll", () => {

    const brightLogo = document.getElementById("fas-logo-bright");
    const darkLogo = document.getElementById("fas-logo");

    if (brightLogo && darkLogo) {
        if (window.location.pathname === "/project" && window.location.search.startsWith("?view=")) {
            let scrollTop = window.scrollY || document.documentElement.scrollTop;

            // pri zmene scroll smeru
            if (scrollTop !== lastScrollTop) {
                if (scrollTop > 0) {
                    if (!brightLogo.classList.contains("d-none")) {
                        brightLogo.classList.remove("d-block");
                        brightLogo.classList.add("d-none");
                        darkLogo.classList.remove("d-none");
                        darkLogo.classList.add("d-block");
                    }
                } else {
                    if (!brightLogo.classList.contains("d-block")) {
                        brightLogo.classList.remove("d-none");
                        brightLogo.classList.add("d-block");
                        darkLogo.classList.remove("d-block");
                        darkLogo.classList.add("d-none");
                    }
                }
                lastScrollTop = scrollTop;
            }
        }
    }

    // COM58 Scroll navbar
    // navbar v sekci work (transparent -> bg pastel-aqua po scrollu)
    let menu = document.getElementById('navbar');
    let hero = document.getElementById('hero');
    if ( menu && hero ) {
        if ( window.scrollY <= 0 ) {
            menu.classList.add('bg-transparent');
            menu.classList.remove('bg-pastel-aqua');
        } else {
            menu.classList.remove('bg-transparent');
            menu.classList.add('bg-pastel-aqua');
        }
    }

    // let w = window.innerWidth;
    let w = globalWidth;
    let h = window.innerHeight;


    // Jen pro vetlka rozliseni 1440+
    if (w >= 1280) { // vypneme pro mensi rozliseni

        // tady zpracujeme efekt s textem (INICIALIZACE)
        let textRight = document.getElementById("tr");
        let textLeft = document.getElementById("tl");
        let textBottom = document.getElementById("tb");

        // Zobrazime texty
        if (textRight) textRight.style.display = 'block';
        if (textLeft) textLeft.style.display = 'block';
        if (textBottom) textBottom.style.display = 'block';

        let scrollHeightMax = 7000; // maximalni scroll pro animaci
        let scrollMaskMax = 4500; // maximalni scroll pro SVG masku

        let other = document.getElementById('other');
        if (!other) {
            lockScroll(lockY, lockRange, lockDuration);
        }


        // odebrani hashe
        const hashRemoveY = 6000; //

        if (window.scrollY > hashRemoveY && window.location.hash) {
            history.replaceState(null, '', window.location.pathname + window.location.search);
        }

        if ( window.scrollY < scrollHeightMax ) {
            let maskContainer = document.getElementById("maskContainer");
            let videoWrapper = document.getElementById("video-wrapper");
            if (maskContainer) maskContainer.style.display = 'block'; // zobrazime masku
            if (maskContainer) maskContainer.style.left = '45%';
            if (videoWrapper) videoWrapper.style.display = 'block'; // zobrazime wrapper videa
        }

        // pozice scrollu v pixelech
        let scrollY = window.scrollY;

        // vypocitame procento scrollu kde scrollHeightMax je 100%
        let scrollPercent = Math.min(scrollY / scrollHeightMax, 1) * 100;
        let scrollMaskPercent = Math.min(scrollY / scrollMaskMax, 1) * 100;

        // console.log('Scroll %: ',scrollPercent)
        // console.log('Scroll Mask %: ',scrollMaskPercent)
        // console.log('Scroll Y: ',scrollY, ", ", scrollHeightMax)

        let maskW = window.innerWidth;
        let maskH = 1440;
        let heroAnimH = 7000; // velikost (prostoru) animace
        let videoAnchor = heroAnimH - maskH; // kde se zastavi posouvani videa
        let tbH = 890;
        let textTop = 300;

        if ( w >= 2560 ) { // QHD 2560x1440 +
              // maskW = 2460;
              maskH = 1440;
              heroAnimH = 7000;
              videoAnchor = heroAnimH - maskH;
              tbH = 890;
              textTop = 300;
        } else if ( w >= 1920 && w < 2560 ) { // FullHD 1920x1080 +
            // maskW = 1920;
            maskH = 1080;
            heroAnimH = 7000;
            videoAnchor = heroAnimH - maskH;
            tbH = 790;
            textTop = 270;
        } else if ( w >= 1440 && w < 1920 ) { // WQHD 1440x900 +
            // Responzivni animace pro 1440x900
            // maskW = 1440;
            maskH = 900 ;
            // velikost (prostoru) animace
            heroAnimH = 7000 //;
            // kde se zastavi posouvani videa
            videoAnchor = heroAnimH - maskH;
            tbH = 704; // text bottom
            textTop = 270; // text top
        } else if ( w >= 1280 && w < 1440 ) { // WXGA 1280x800 +
            // maskW = 1280;
            maskH = 800;
            heroAnimH = 7000;
            videoAnchor = heroAnimH - maskH;
            tbH = 624;
            textTop = 240;
        } // mensi uz neanimujeme

        let opacityLevel = 50;
        let maskMoveLevel = 2;

        // responzivni text:
        if (textLeft) {
            textLeft.style.opacity = 0.99 - (scrollMaskPercent / opacityLevel );
            textLeft.style.position = "fixed";
            textLeft.style.top = textTop+"px";
            textLeft.style.transition = "all 1ms ease-out";
            textLeft.style.left = "0";
            textLeft.style.right = "60%";
            textLeft.style.transform = "translateX(-"+scrollMaskPercent+"%)";
        }
        if (textRight) {
            textRight.style.opacity = 0.99 - (scrollMaskPercent / opacityLevel);
            textRight.style.position = "fixed";
            textRight.style.top = textTop+"px";
            textRight.style.transition = "all 1ms ease-out";
            textRight.style.right = "0";
            textRight.style.left = "60%";
            textRight.style.transform = "translateX("+scrollMaskPercent+"%)";
        }
        if (textBottom) {
            textBottom.style.opacity = 0.99 - (scrollMaskPercent / opacityLevel);
            textBottom.style.position = "fixed";
            textBottom.style.transition = "all 1ms ease-out";
            textBottom.style.top = tbH + "px";
            textBottom.style.top = (tbH + (scrollMaskPercent * 2)) + `px`;
        }


        // nastaveni masky
        let newSize1 = maskW;
        let newSize2 = maskH;

        // Zvetsovani masky scrollovanim
        if (scrollMaskPercent >= 5 ) { // masku zacnem zvetsovat od 5% z celkoveho scrollu MASKY, protoze v uvodu mame 0.000232 a mensi, coz zmensi masku
            newSize1 = maskW * (scrollMaskPercent/5);
            newSize2 = maskH * (scrollMaskPercent/5);
        }

        // // velikost masky pokud prekrocime min velikost
        if (newSize1 < maskW && scrollPercent < 3) {
            newSize1 = maskW;
            newSize2 = maskH;
        }

        let videoWrapper = document.getElementById("video-wrapper");
        let alayer1 = document.getElementById("a-layer-1");
        let maskContainer = document.getElementById("maskContainer");
        let heroAnimation = document.getElementById("hero-animation");

        if (heroAnimation) {
            heroAnimation.style.height = heroAnimH + "px";
        }


        // pri odscrollovani SVG masky ji skryjeme
        if (maskContainer) {
            if (scrollY >= 4500) {
                maskContainer.style.display = "none";
            } else {
                maskContainer.style.display = "block";
            }
        }


        // Opusteni/navrat animace
        if (maskContainer) {
            if (scrollY >= videoAnchor) { // a ted zpracujeme konec animace

                alayer1.style.position = "relative";
                videoWrapper.style.position = "relative";
                videoWrapper.style.top = videoAnchor + "px";
                videoWrapper.style.zIndex = "900";

            } else if (scrollY < videoAnchor) { // vratime animaci
                alayer1.style.position = "fixed";
                maskContainer.style.width = newSize1 + "px";
                maskContainer.style.height = newSize2 + "px";
                // maskContainer.style.opacity = ((100 - (scrollY * 10)) / 100);
                videoWrapper.style.position = "fixed";
                videoWrapper.style.top = "112px";
                videoWrapper.style.zIndex = "-1";
            }
        }

    } else {
        // < 1280
        // PRO MENSI ROZLISENI se vypne animace

        let textRight = document.getElementById("tr");
        let textLeft = document.getElementById("tl");
        let textBottom = document.getElementById("tb");
        let videoWrapper = document.getElementById("video-wrapper");
        let alayer1 = document.getElementById("a-layer-1");
        let maskContainer = document.getElementById("maskContainer");
        let heroAnimation = document.getElementById("hero-animation");
        if (maskContainer) maskContainer.style.display = 'none'; // skryjeme masku
        if(textRight) textRight.style.display = 'none'; // skryjeme text
        if(textLeft) textLeft.style.display = 'none'; // skryjeme text
        if(textBottom) textBottom.style.display = 'none'; // skryjeme text
        if(alayer1) alayer1.style.position = "relative";
        if(videoWrapper) videoWrapper.style.position = "relative";
        if(videoWrapper) videoWrapper.style.top = "0";
        if(heroAnimation) heroAnimation.style.height = "100%";
        if (maskContainer) maskContainer.style.display = 'none'; //
        if (videoWrapper) videoWrapper.style.display = 'block'; //
    }
});

/*
* #fas-logo
* #navbar-mask
* #content
* menu-wrapper
* text
* from-left
* from-right
* from-bottom
* entry-mask
* */
// document.getElementById("fas-logo").addEventListener("click", function () {



if (navbarMask) {

    const heroMask = document.getElementById("hero-mask");
    heroMask.style.display = "block";

// Spustíme animaci
    setTimeout(() => {
        navbarMask.style.display = "none";

        // Nastavíme plynulý přesun loga
        logo.style.transition = "all 1.2s cubic-bezier(0.4, 0, 0.2, 1)";
        logo.style.position = "relative";
        logo.style.top = 0;
        logo.style.left = 0;
        logo.style.transform = "translate(0, 0)";

        // Po dokončení animace spustíme další kód
        logo.addEventListener("transitionend", () => {
            afterAnimation();
            heroMask.style.display = "none";
            // Sem dej další JavaScriptový kód
        }, { once: true }); // `once: true` zajistí, že event handler se spustí jen jednou
    }, 1000);

} else {

    // tady pokud se uz animace jednou odehrala a uz se zobrazi rovnou scro
    afterAnimation();

}



function afterAnimation() {
    let heroMask = document.getElementById("hero-mask");
    if (heroMask) heroMask.style.display = "none"; // vypnu masku pokud stale existuje

    logo.style.transition = "all 0s";
    logo.style.position = "relative";
    logo.style.top = 0;
    logo.style.left = 0;
    logo.style.transform = "translate(0, 0)";

    let other = document.getElementById('other');
    if (!other) {

        let transitioned = false;

        // Zobraz skrytý obsah
        document.getElementById("content").classList.remove("hidden");

        // Menu přejede z pravé strany
        const menuwrapper = document.querySelector(".menu-wrapper");
        setTimeout(() => {
            menuwrapper.style.opacity = 1;
            menuwrapper.style.right = "0";
            menuwrapper.style.top = "20";
        }, 0);


        if ( globalWidth < 1280 ) {

            // Pokud mame mobilni nebo tablet rozliseni
            updateGlobalWidth();

        } else {

            // pokud mame vetsi nez rozliseni tabletu


            // Synchronizovaná animace textů
            const texts = document.querySelectorAll(".text");
            setTimeout(() => {
                // texts.forEach((text) => {
                //     text.style.opacity = 1;
                //     text.style.transform = "translateX(0) translateY(0) scale(1)";
                // });


                // // Animace pro texty zleva a zprava a zdola
                // const leftText = document.querySelector(".from-left");
                // const rightText = document.querySelector(".from-right");
                // const bottomText = document.querySelector(".from-bottom");
                // const screenHeight = window.innerHeight;
                //
                // leftText.style.opacity = 1;
                // leftText.style.transform = "translateX(0)";  /* Text přijede zleva */
                // rightText.style.opacity = 1;
                // rightText.style.transform = "translateX(0)"; /* Text přijede zprava */
                //
                // if ( globalWidth >= 2560) {
                //     bottomText.style.top = '890px';
                // } else if ( globalWidth >= 1920 && globalWidth < 2560 ) {
                //     bottomText.style.top = '790px';
                // } else if ( globalWidth >= 1440 && globalWidth < 1920 ) {
                //     bottomText.style.top = '704px';
                // } else if ( globalWidth >= 1280 && globalWidth < 1440 ) {
                //     bottomText.style.top = '624px';
                // } // mensi uz neanimujeme
                //
                // bottomText.style.opacity = 1;
                // bottomText.style.transform = "translateX(-50%) translateY(-50%)"; /* Tlačí text do středu */

                // Spustí další akci až po dokončení animace
                // bottomText.addEventListener("transitionend", function () {
                //
                //     if (transitioned === false) {
                //         transitioned = true;
                //         document.getElementById("hero-mask").style.display = "none";
                //     }
                //     document.body.style.removeProperty('overflow');
                //
                // });

                // document.body.style.minHeight = 'calc(100vh * 4)';
            }, 300);

        } // IF - tablet nebo desktop


    } else {
        // Menu přejede z pravé strany

        const menuwrapper = document.querySelector(".menu-wrapper");
        menuwrapper.style.opacity = 1;
        menuwrapper.style.right = "0";
        menuwrapper.style.top = "20";
        menuwrapper.style.position = "relative";
        menuwrapper.transition = 0;
        menuwrapper.style.right = 0;
        document.body.style.removeProperty('overflow');
    }
}

